import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=c23a046c&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=c23a046c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23a046c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c23a046c')) {
      api.createRecord('c23a046c', component.options)
    } else {
      api.reload('c23a046c', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=c23a046c&scoped=true&", function () {
      api.rerender('c23a046c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vug0To52u0oP/JS/comp/DocBox.vue"
export default component.exports